import { render, staticRenderFns } from "./quick-order-master.vue?vue&type=template&id=327c754e&scoped=true&"
import script from "./quick-order-master.vue?vue&type=script&lang=js&"
export * from "./quick-order-master.vue?vue&type=script&lang=js&"
import style0 from "./quick-order-master.vue?vue&type=style&index=0&id=327c754e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327c754e",
  null
  
)

export default component.exports